import { getTenantSlug } from "@/utils/tenantScope";

/**
 * O link do cardápio que vai no anúncio da Meta (Instagram/Facebook).
 * `c=<código>` é o link "Anúncios Meta" de Links de divulgação; as macros a
 * Meta troca pelos ids da campanha, do conjunto e do anúncio em cada clique —
 * é o que faz o pedido nascer marcado com a campanha que o trouxe.
 */
export const MACROS_META = "nc_c={{campaign.id}}&nc_as={{adset.id}}&nc_ad={{ad.id}}";

export function linkAnuncioMeta(trackToken) {
  const url = `https://${getTenantSlug()}.usenucleo.com.br/cardapio`;
  return {
    url,                                          // Gerenciador: campo "URL do site"
    parametros: `c=${trackToken}&${MACROS_META}`,   // Gerenciador: campo "Parâmetros de URL"
    simples: `${url}?c=${trackToken}`,              // turbinar pelo app: um campo só
  };
}
